import { PreviewModel } from "../preview/preview_scenes";

/**
 * @internal
 */
const DisplayReferences = {
	display_player: {
		texture: 'assets/player_skin.png',
		texture_size: [64, 64],
		elements: [
			{
				//Head
				"name": "head",
				"size": [8, 8, 8],
				"pos": [0, 28, 0],
				"origin": [0, 24, 0],
				"north": {"uv": [8, 8, 16, 16]},
				"east": {"uv": [0, 8, 8, 16]},
				"south": {"uv": [24, 8, 32, 16]},
				"west": {"uv": [16, 8, 24, 16]},
				"up": {"uv": [16, 8, 8, 0]},
				"down": {"uv": [24, 0, 16, 8]}
			},
			{
				//Head Layer
				"name": "head_layer",
				"size": [9, 9, 9],
				"pos": [0, 28, 0],
				"origin": [0, 24, 0],
				"north": {"uv": [40, 8, 48, 16]},
				"east": {"uv": [32, 8, 40, 16]},
				"south": {"uv": [56, 8, 64, 16]},
				"west": {"uv": [48, 8, 56, 16]},
				"up": {"uv": [48, 8, 40, 0]},
				"down": {"uv": [56, 0, 48, 8]}
			},
			{
				//Body
				"size": [8, 12, 4],
				"pos": [0, 18, 0],
				"north": {"uv": [20, 20, 28, 32]},
				"east": {"uv": [16, 20, 20, 32]},
				"south": {"uv": [32, 20, 40, 32]},
				"west": {"uv": [28, 20, 32, 32]},
				"up": {"uv": [20, 20, 28, 16]},
				"down": {"uv": [28, 16, 36, 20]}
			},
			{
				//Body Layer
				"size": [8.5, 12.5, 4.5],
				"pos": [0, 18, 0],
				"north": {"uv": [20, 36, 28, 48]},
				"east": {"uv": [16, 36, 20, 48]},
				"south": {"uv": [32, 36, 40, 48]},
				"west": {"uv": [28, 36, 32, 48]},
				"up": {"uv": [20, 36, 28, 32]},
				"down": {"uv": [28, 32, 36, 36]}
			},
			{
				//R Leg
				"size": [4, 12, 4],
				"pos": [1.95, 6, 0],
				"origin": [0, 12, 0],
				"rotation": [-1, 0, 0],
				"north": {"uv": [4, 20, 8, 32]},
				"east": {"uv": [0, 20, 4, 32]},
				"south": {"uv": [12, 20, 16, 32]},
				"west": {"uv": [8, 20, 12, 32]},
				"up": {"uv": [8, 20, 4, 16]},
				"down": {"uv": [12, 16, 8, 20]}
			},
			{
				//R Leg Layer
				"size": [4.5, 12.5, 4.5],
				"pos": [1.95, 6, 0],
				"origin": [0, 12, 0],
				"rotation": [-1, 0, 0],
				"north": {"uv": [4, 36, 8, 48]},
				"east": {"uv": [0, 36, 4, 48]},
				"south": {"uv": [12, 36, 16, 48]},
				"west": {"uv": [8, 36, 12, 48]},
				"up": {"uv": [8, 36, 4, 32]},
				"down": {"uv": [12, 32, 8, 36]}
			},
			{
				//L Leg
				"size": [4, 12, 4],
				"pos": [-1.95, 6, 0],
				"origin": [0, 12, 0],
				"rotation": [1, 0, 0],
				"north": {"uv": [20, 52, 24, 64]},
				"east": {"uv": [16, 52, 20, 64]},
				"south": {"uv": [28, 52, 32, 64]},
				"west": {"uv": [24, 52, 28, 64]},
				"up": {"uv": [24, 52, 20, 48]},
				"down": {"uv": [28, 48, 24, 52]}
			},
			{
				//L Leg Layer
				"size": [4.5, 12.5, 4.5],
				"pos": [-1.95, 6, 0],
				"origin": [0, 12, 0],
				"rotation": [1, 0, 0],
				"north": {"uv": [4, 52, 8, 64]},
				"east": {"uv": [0, 52, 4, 64]},
				"south": {"uv": [12, 52, 16, 64]},
				"west": {"uv": [8, 52, 12, 64]},
				"up": {"uv": [8, 52, 4, 48]},
				"down": {"uv": [12, 48, 8, 52]}
			},
			//Steve
			{
				"name": "right_arm",
				"size": [4, 12, 4],
				"pos": [6, 18, 0],
				"origin": [4, 22, 0],
				"rotation": [22.5, 0, 0],
				"north": {"uv": [44, 20, 48, 32]},
				"east": {"uv": [40, 20, 44, 32]},
				"south": {"uv": [52, 20, 56, 32]},
				"west": {"uv": [48, 20, 52, 32]},
				"up": {"uv": [48, 20, 44, 16]},
				"down": {"uv": [52, 16, 48, 20]},
				"model": "steve"
			},
			{
				"name": "right_arm_layer",
				"size": [4.5, 12.5, 4.5],
				"pos": [6, 18, 0],
				"origin": [4, 22, 0],
				"rotation": [22.5, 0, 0],
				"north": {"uv": [44, 36, 48, 48]},
				"east": {"uv": [40, 36, 44, 48]},
				"south": {"uv": [52, 36, 56, 48]},
				"west": {"uv": [48, 36, 52, 48]},
				"up": {"uv": [48, 36, 44, 32]},
				"down": {"uv": [52, 32, 48, 36]},
				"model": "steve"
			},
			{
				"name": "left_arm",
				"size": [4, 12, 4],
				"pos": [-6, 18, 0],
				"origin": [-4, 22, 0],
				"rotation": [22.5, 0, 0],
				"north": {"uv": [36, 52, 40, 64]},
				"east": {"uv": [32, 52, 36, 64]},
				"south": {"uv": [44, 52, 48, 64]},
				"west": {"uv": [40, 52, 44, 64]},
				"up": {"uv": [40, 52, 36, 48]},
				"down": {"uv": [44, 48, 40, 52]},
				"model": "steve"
			},
			{
				"name": "left_arm_layer",
				"size": [4.5, 12.5, 4.5],
				"pos": [-6, 18, 0],
				"origin": [-4, 22, 0],
				"rotation": [22.5, 0, 0],
				"north": {"uv": [52, 52, 56, 64]},
				"east": {"uv": [48, 52, 52, 64]},
				"south": {"uv": [60, 52, 64, 64]},
				"west": {"uv": [56, 52, 60, 64]},
				"up": {"uv": [56, 52, 52, 48]},
				"down": {"uv": [60, 48, 56, 52]},
				"model": "steve"
			},
			//Alex
			{
				"name": "right_arm",
				"size": [3, 12, 4],
				"pos": [5.5, 17.5, 0],
				"origin": [4, 22, 0],
				"rotation": [22.5, 0, 0],
				"north": {"uv": [44, 20, 47, 32]},
				"east": {"uv": [40, 20, 44, 32]},
				"south": {"uv": [51, 20, 54, 32]},
				"west": {"uv": [47, 20, 51, 32]},
				"up": {"uv": [47, 20, 44, 16]},
				"down": {"uv": [50, 16, 47, 20]},
				"model": "alex"
			},
			{
				"name": "right_arm_layer",
				"size": [3.5, 12.5, 4.5],
				"pos": [5.5, 17.5, 0],
				"origin": [4, 22, 0],
				"rotation": [22.5, 0, 0],
				"north": {"uv": [44, 36, 47, 48]},
				"east": {"uv": [40, 36, 44, 48]},
				"south": {"uv": [51, 36, 54, 48]},
				"west": {"uv": [47, 36, 51, 48]},
				"up": {"uv": [47, 36, 44, 32]},
				"down": {"uv": [50, 32, 47, 36]},
				"model": "alex"
			},
			{
				"name": "left_arm",
				"size": [3, 12, 4],
				"pos": [-5.5, 17.5, 0],
				"origin": [-4, 22, 0],
				"rotation": [22.5, 0, 0],
				"north": {"uv": [36, 52, 39, 64]},
				"east": {"uv": [32, 52, 36, 64]},
				"south": {"uv": [43, 52, 46, 64]},
				"west": {"uv": [39, 52, 43, 64]},
				"up": {"uv": [39, 52, 36, 48]},
				"down": {"uv": [42, 48, 39, 52]},
				"model": "alex"
			},
			{
				"name": "left_arm_layer",
				"size": [3.5, 12.5, 4.5],
				"pos": [-5.5, 17.5, 0],
				"origin": [-4, 22, 0],
				"rotation": [22.5, 0, 0],
				"north": {"uv": [52, 52, 55, 64]},
				"east": {"uv": [48, 52, 52, 64]},
				"south": {"uv": [59, 52, 62, 64]},
				"west": {"uv": [55, 52, 59, 64]},
				"up": {"uv": [55, 52, 52, 48]},
				"down": {"uv": [58, 48, 55, 52]},
				"model": "alex"
			}
		]
	},
	armor_stand: {
		texture: 'assets/armor_stand.png',
		texture_size: [64, 64],
		elements: [
			{
				"size": [12, 1, 12],
				"pos": [0, 0.5, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [12, 44, 24, 45]},
				"east": {"uv": [0, 44, 12, 45]},
				"south": {"uv": [36, 44, 48, 45]},
				"west": {"uv": [24, 44, 36, 45]},
				"up": {"uv": [24, 44, 12, 32]},
				"down": {"uv": [36, 32, 24, 44]}
			},
			{
				"size": [12, 3, 3],
				"pos": [0, 22.5, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [3, 29, 15, 32]},
				"east": {"uv": [0, 29, 3, 32]},
				"south": {"uv": [18, 29, 30, 32]},
				"west": {"uv": [15, 29, 18, 32]},
				"up": {"uv": [15, 29, 3, 26]},
				"down": {"uv": [27, 26, 15, 29]}
			},
			{
				"size": [2, 7, 2],
				"pos": [2, 17.5, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [18, 2, 20, 9]},
				"east": {"uv": [16, 2, 18, 9]},
				"south": {"uv": [22, 2, 24, 9]},
				"west": {"uv": [20, 2, 22, 9]},
				"up": {"uv": [20, 2, 18, 0]},
				"down": {"uv": [22, 0, 20, 2]}
			},
			{
				"size": [2, 7, 2],
				"pos": [-2, 17.5, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [50, 18, 52, 25]},
				"east": {"uv": [48, 18, 50, 25]},
				"south": {"uv": [54, 18, 56, 25]},
				"west": {"uv": [52, 18, 54, 25]},
				"up": {"uv": [52, 18, 50, 16]},
				"down": {"uv": [54, 16, 52, 18]}
			},
			{
				"size": [8, 2, 2],
				"pos": [0, 13, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [2, 50, 10, 52]},
				"east": {"uv": [0, 50, 2, 52]},
				"south": {"uv": [12, 50, 20, 52]},
				"west": {"uv": [10, 50, 12, 52]},
				"up": {"uv": [10, 50, 2, 48]},
				"down": {"uv": [18, 48, 10, 50]}
			},
			{
				"size": [2, 7, 2],
				"pos": [0, 26.5, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [2, 2, 4, 9]},
				"east": {"uv": [0, 2, 2, 9]},
				"south": {"uv": [6, 2, 8, 9]},
				"west": {"uv": [4, 2, 6, 9]},
				"up": {"uv": [4, 2, 2, 0]},
				"down": {"uv": [6, 0, 4, 2]}
			},
			{
				"size": [2, 12, 2],
				"pos": [-6, 18, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [36, 18, 34, 30]},
				"east": {"uv": [38, 18, 36, 30]},
				"south": {"uv": [40, 18, 38, 30]},
				"west": {"uv": [34, 18, 32, 30]},
				"up": {"uv": [34, 18, 36, 16]},
				"down": {"uv": [36, 16, 38, 18]}
			},
			{
				"size": [2, 11, 2],
				"pos": [-1.9, 6.5, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [44, 18, 42, 29]},
				"east": {"uv": [46, 18, 44, 29]},
				"south": {"uv": [48, 18, 46, 29]},
				"west": {"uv": [42, 18, 40, 29]},
				"up": {"uv": [42, 18, 44, 16]},
				"down": {"uv": [44, 16, 46, 18]}
			},
			{
				"size": [2, 12, 2],
				"pos": [6, 18, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [26, 2, 28, 14]},
				"east": {"uv": [24, 2, 26, 14]},
				"south": {"uv": [30, 2, 32, 14]},
				"west": {"uv": [28, 2, 30, 14]},
				"up": {"uv": [28, 2, 26, 0]},
				"down": {"uv": [30, 0, 28, 2]}
			},
			{
				"size": [2, 11, 2],
				"pos": [1.9, 6.5, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [10, 2, 12, 13]},
				"east": {"uv": [8, 2, 10, 13]},
				"south": {"uv": [14, 2, 16, 13]},
				"west": {"uv": [12, 2, 14, 13]},
				"up": {"uv": [12, 2, 10, 0]},
				"down": {"uv": [14, 0, 12, 2]}
			}
		],
	},
	armor_stand_small: {
		texture: 'assets/armor_stand.png',
		texture_size: [64, 64],
		elements: [
			{
				"size": [6, 0.5, 6],
				"pos": [0, 0.25, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [12, 44, 24, 45]},
				"east": {"uv": [0, 44, 12, 45]},
				"south": {"uv": [36, 44, 48, 45]},
				"west": {"uv": [24, 44, 36, 45]},
				"up": {"uv": [24, 44, 12, 32]},
				"down": {"uv": [36, 32, 24, 44]}
			},
			{
				"size": [6, 1.5, 1.5],
				"pos": [0, 11.25, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [3, 29, 15, 32]},
				"east": {"uv": [0, 29, 3, 32]},
				"south": {"uv": [18, 29, 30, 32]},
				"west": {"uv": [15, 29, 18, 32]},
				"up": {"uv": [15, 29, 3, 26]},
				"down": {"uv": [27, 26, 15, 29]}
			},
			{
				"size": [1, 3.5, 1],
				"pos": [1, 8.75, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [18, 2, 20, 9]},
				"east": {"uv": [16, 2, 18, 9]},
				"south": {"uv": [22, 2, 24, 9]},
				"west": {"uv": [20, 2, 22, 9]},
				"up": {"uv": [20, 2, 18, 0]},
				"down": {"uv": [22, 0, 20, 2]}
			},
			{
				"size": [1, 3.5, 1],
				"pos": [-1, 8.75, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [50, 18, 52, 25]},
				"east": {"uv": [48, 18, 50, 25]},
				"south": {"uv": [54, 18, 56, 25]},
				"west": {"uv": [52, 18, 54, 25]},
				"up": {"uv": [52, 18, 50, 16]},
				"down": {"uv": [54, 16, 52, 18]}
			},
			{
				"size": [4, 1, 1],
				"pos": [0, 6.5, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [2, 50, 10, 52]},
				"east": {"uv": [0, 50, 2, 52]},
				"south": {"uv": [12, 50, 20, 52]},
				"west": {"uv": [10, 50, 12, 52]},
				"up": {"uv": [10, 50, 2, 48]},
				"down": {"uv": [18, 48, 10, 50]}
			},
			{
				"size": [1.5, 5.25, 1.48],
				"pos": [0, 13.875, 0],
				"origin": [0, 12, 0],
				"north": {"uv": [2, 2, 4, 9]},
				"east": {"uv": [0, 2, 2, 9]},
				"south": {"uv": [6, 2, 8, 9]},
				"west": {"uv": [4, 2, 6, 9]},
				"up": {"uv": [4, 2, 2, 0]},
				"down": {"uv": [6, 0, 4, 2]}
			},
			{
				"size": [1, 6, 1],
				"pos": [-3, 9, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [36, 18, 34, 30]},
				"east": {"uv": [38, 18, 36, 30]},
				"south": {"uv": [40, 18, 38, 30]},
				"west": {"uv": [34, 18, 32, 30]},
				"up": {"uv": [34, 18, 36, 16]},
				"down": {"uv": [36, 16, 38, 18]}
			},
			{
				"size": [1, 5.5, 1],
				"pos": [-0.95, 3.25, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [44, 18, 42, 29]},
				"east": {"uv": [46, 18, 44, 29]},
				"south": {"uv": [48, 18, 46, 29]},
				"west": {"uv": [42, 18, 40, 29]},
				"up": {"uv": [42, 18, 44, 16]},
				"down": {"uv": [44, 16, 46, 18]}
			},
			{
				"size": [1, 6, 1],
				"pos": [3, 9, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [26, 2, 28, 14]},
				"east": {"uv": [24, 2, 26, 14]},
				"south": {"uv": [30, 2, 32, 14]},
				"west": {"uv": [28, 2, 30, 14]},
				"up": {"uv": [28, 2, 26, 0]},
				"down": {"uv": [30, 0, 28, 2]}
			},
			{
				"size": [1, 5.5, 1],
				"pos": [0.95, 3.25, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [10, 2, 12, 13]},
				"east": {"uv": [8, 2, 10, 13]},
				"south": {"uv": [14, 2, 16, 13]},
				"west": {"uv": [12, 2, 14, 13]},
				"up": {"uv": [12, 2, 10, 0]},
				"down": {"uv": [14, 0, 12, 2]}
			}
		],
	},
	fox: {
		texture: 'assets/fox.png',
		texture_size: [32, 32],
		elements: [
			{
				"size": [8, 6, 6],
				"pos": [0, 4, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [7, 11, 15, 17]},
				"east": {"uv": [1, 11, 7, 17]},
				"south": {"uv": [21, 11, 29, 17]},
				"west": {"uv": [15, 11, 21, 17]},
				"up": {"uv": [15, 11, 7, 5]},
				"down": {"uv": [23, 5, 15, 11]}
			},
			{
				"size": [4, 2, 3],
				"pos": [0, 2, -4.5],
				"origin": [0, 0, 0],
				"north": {"uv": [9, 21, 13, 23]},
				"east": {"uv": [6, 21, 9, 23]},
				"south": {"uv": [16, 21, 20, 23]},
				"west": {"uv": [13, 21, 16, 23]},
				"up": {"uv": [13, 21, 9, 18]},
				"down": {"uv": [17, 18, 13, 21]}
			},
			{
				"size": [2, 2, 1],
				"pos": [3, 8, -1.5],
				"origin": [0, 0, 0],
				"north": {"uv": [9, 2, 11, 4]},
				"east": {"uv": [8, 2, 9, 4]},
				"south": {"uv": [12, 2, 14, 4]},
				"west": {"uv": [11, 2, 12, 4]},
				"up": {"uv": [11, 2, 9, 1]},
				"down": {"uv": [13, 1, 11, 2]}
			},
			{
				"size": [2, 2, 1],
				"pos": [-3, 8, -1.5],
				"origin": [0, 0, 0],
				"north": {"uv": [16, 2, 18, 4]},
				"east": {"uv": [15, 2, 16, 4]},
				"south": {"uv": [19, 2, 21, 4]},
				"west": {"uv": [18, 2, 19, 4]},
				"up": {"uv": [18, 2, 16, 1]},
				"down": {"uv": [20, 1, 18, 2]}
			}

		]
	},
	zombie: {
		texture: 'assets/zombie.png',
		elements: [
			{
				"size": [4, 12, 4],
				"pos": [0, 0, -2],
				"origin": [0, 0, 0],
				"north": {"uv": [0.01, 5.01, 0.99, 7.99], "texture": "#1"},
				"east": {"uv": [3.01, 5.01, 3.99, 7.99], "texture": "#1"},
				"south": {"uv": [2.01, 5.01, 2.99, 7.99], "texture": "#1"},
				"west": {"uv": [1.01, 5.01, 1.99, 7.99], "texture": "#1"},
				"up": {"uv": [1.01, 4.01, 1.99, 4.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [2.01, 4.01, 2.99, 4.99], "texture": "#1", "rotation": 90}
			},
			{
				"size": [4, 12, 4],
				"pos": [0, 0, 2],
				"origin": [0, 0, 0],
				"north": {"uv": [4.01, 13.01, 4.99, 15.99], "texture": "#1"},
				"east": {"uv": [8.01, 13.01, 6.99, 15.99], "texture": "#1"},
				"south": {"uv": [6.01, 13.01, 6.99, 15.99], "texture": "#1"},
				"west": {"uv": [5.01, 13.01, 5.99, 15.99], "texture": "#1"},
				"up": {"uv": [5.01, 12.01, 5.99, 12.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [6.01, 12.01, 6.99, 12.99], "texture": "#1", "rotation": 90}
			},
			{
				"size": [4, 12, 8],
				"pos": [0, 12, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [4.01, 5.01, 4.99, 7.99], "texture": "#1"},
				"east": {"uv": [8.01, 5.01, 9.99, 7.99], "texture": "#1"},
				"south": {"uv": [7.01, 5.01, 7.99, 7.99], "texture": "#1"},
				"west": {"uv": [5.01, 5.01, 6.99, 7.99], "texture": "#1"},
				"up": {"uv": [5.01, 4.01, 6.99, 4.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [7.01, 4.01, 8.99, 4.99], "texture": "#1", "rotation": 270}
			},
			{
				"size": [8, 8, 8],
				"pos": [0, 22, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [0.01, 2.01, 1.99, 3.99], "texture": "#1"},
				"east": {"uv": [6.01, 2.01, 7.99, 3.99], "texture": "#1"},
				"south": {"uv": [4.01, 2.01, 5.99, 3.99], "texture": "#1"},
				"west": {"uv": [2.01, 2.01, 3.99, 3.99], "texture": "#1"},
				"up": {"uv": [2.01, 0.01, 3.99, 1.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [4.01, 0.01, 5.99, 1.99], "texture": "#1", "rotation": 90}
			},
			{
				"size": [12, 4, 4],
				"pos": [-4, 16, -6],
				"origin": [0, 0, 0],
				"north": {"uv": [12.01, 5.01, 12.99, 7.99], "texture": "#1", "rotation": 270},
				"east": {"uv": [11.01, 4.01, 11.99, 4.99], "texture": "#1", "rotation": 180},
				"south": {"uv": [10.01, 5.01, 10.99, 7.99], "texture": "#1", "rotation": 90},
				"west": {"uv": [12.01, 4.01, 12.99, 4.99], "texture": "#1", "rotation": 180},
				"up": {"uv": [11.01, 5.01, 11.99, 7.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [13.01, 5.01, 13.99, 7.99], "texture": "#1", "rotation": 90}
			},
			{
				"size": [12, 4, 4],
				"pos": [-4, 16, 6],
				"origin": [0, 0, 0],
				"north": {"uv": [10.01, 13.01, 10.99, 15.99], "texture": "#1", "rotation": 270},
				"east": {"uv": [9.01, 12.01, 9.99, 12.99], "texture": "#1", "rotation": 180},
				"south": {"uv": [8.01, 13.01, 8.99, 15.99], "texture": "#1", "rotation": 90},
				"west": {"uv": [10.01, 12.01, 10.99, 12.99], "texture": "#1", "rotation": 180},
				"up": {"uv": [9.01, 13.01, 9.99, 15.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [11.01, 13.01, 11.99, 15.99], "texture": "#1", "rotation": 90}
			}
		]
	},
	baby_zombie: {
		texture: 'assets/zombie.png',
		elements: [
			{
				"size": [2, 6, 2],
				"pos": [-2.220446049250313e-16, -3, -1],
				"origin": [0, 0, 0],
				"north": {"uv": [0.01, 5.01, 0.99, 7.99], "texture": "#1"},
				"east": {"uv": [3.01, 5.01, 3.99, 7.99], "texture": "#1"},
				"south": {"uv": [2.01, 5.01, 2.99, 7.99], "texture": "#1"},
				"west": {"uv": [1.01, 5.01, 1.99, 7.99], "texture": "#1"},
				"up": {"uv": [1.01, 4.01, 1.99, 4.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [2.01, 4.01, 2.99, 4.99], "texture": "#1", "rotation": 90}
			},
			{
				"size": [2, 6, 2],
				"pos": [-2.220446049250313e-16, -3, 1],
				"origin": [0, 0, 0],
				"north": {"uv": [4.01, 13.01, 4.99, 15.99], "texture": "#1"},
				"east": {"uv": [8.01, 13.01, 6.99, 15.99], "texture": "#1"},
				"south": {"uv": [6.01, 13.01, 6.99, 15.99], "texture": "#1"},
				"west": {"uv": [5.01, 13.01, 5.99, 15.99], "texture": "#1"},
				"up": {"uv": [5.01, 12.01, 5.99, 12.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [6.01, 12.01, 6.99, 12.99], "texture": "#1", "rotation": 90}
			},
			{
				"size": [2, 6, 4],
				"pos": [-2.220446049250313e-16, 3, 0],
				"origin": [0, 0, 0],
				"north": {"uv": [4.01, 5.01, 4.99, 7.99], "texture": "#1"},
				"east": {"uv": [8.01, 5.01, 9.99, 7.99], "texture": "#1"},
				"south": {"uv": [7.01, 5.01, 7.99, 7.99], "texture": "#1"},
				"west": {"uv": [5.01, 5.01, 6.99, 7.99], "texture": "#1"},
				"up": {"uv": [5.01, 4.01, 6.99, 4.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [7.01, 4.01, 8.99, 4.99], "texture": "#1", "rotation": 270}
			},
			{
				"size": [6.0, 6.0, 6.0],
				"pos": [0, 9, 0],
				"origin": [0, 9, 0],
				"north": {"uv": [0.01, 2.01, 1.99, 3.99], "texture": "#1"},
				"east": {"uv": [6.01, 2.01, 7.99, 3.99], "texture": "#1"},
				"south": {"uv": [4.01, 2.01, 5.99, 3.99], "texture": "#1"},
				"west": {"uv": [2.01, 2.01, 3.99, 3.99], "texture": "#1"},
				"up": {"uv": [2.01, 0.01, 3.99, 1.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [4.01, 0.01, 5.99, 1.99], "texture": "#1", "rotation": 90}
			},
			{
				"size": [6, 2, 2],
				"pos": [-2.000000000000001, 5, -3],
				"origin": [0, 0, 0],
				"north": {"uv": [12.01, 5.01, 12.99, 7.99], "texture": "#1", "rotation": 270},
				"east": {"uv": [11.01, 4.01, 11.99, 4.99], "texture": "#1", "rotation": 180},
				"south": {"uv": [10.01, 5.01, 10.99, 7.99], "texture": "#1", "rotation": 90},
				"west": {"uv": [12.01, 4.01, 12.99, 4.99], "texture": "#1", "rotation": 180},
				"up": {"uv": [11.01, 5.01, 11.99, 7.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [13.01, 5.01, 13.99, 7.99], "texture": "#1", "rotation": 90}
			},
			{
				"size": [6, 2, 2],
				"pos": [-2.000000000000001, 5, 3],
				"origin": [0, 0, 0],
				"north": {"uv": [10.01, 13.01, 10.99, 15.99], "texture": "#1", "rotation": 270},
				"east": {"uv": [9.01, 12.01, 9.99, 12.99], "texture": "#1", "rotation": 180},
				"south": {"uv": [8.01, 13.01, 8.99, 15.99], "texture": "#1", "rotation": 90},
				"west": {"uv": [10.01, 12.01, 10.99, 12.99], "texture": "#1", "rotation": 180},
				"up": {"uv": [9.01, 13.01, 9.99, 15.99], "texture": "#1", "rotation": 90},
				"down": {"uv": [11.01, 13.01, 11.99, 15.99], "texture": "#1", "rotation": 90}
			}
		],
	},
	monitor: {
		texture: 'black',
		elements: [
			{"size": [8, 8, 0.1], "pos": [0, 28.93, 31.20], "origin": [0, 0, 0], "north":{"uv":[0,0,0,0]},"east":{"uv":[0,0,0,0]},"south":{"uv":[0,0,0,0]},"west":{"uv":[0,0,16,16]},"up":{"uv":[0,0,0,0]},"down":{"uv":[0,0,0,0]}},
			{"size": [8, 8, 0.1], "pos": [0, 19.07, 31.20], "origin": [0, 0, 0], "north":{"uv":[0,0,0,0]},"east":{"uv":[0,0,0,0]},"south":{"uv":[0,0,0,0]},"west":{"uv":[0,0,16,16]},"up":{"uv":[0,0,0,0]},"down":{"uv":[0,0,0,0]}},
			{"size": [8, 8, 0.1], "pos": [5.65, 24, 31.2], "origin": [0, 0, 0], "north":{"uv":[0,0,0,0]},"east":{"uv":[0,0,0,0]},"south":{"uv":[0,0,0,0]},"west":{"uv":[0,0,16,16]},"up":{"uv":[0,0,0,0]},"down":{"uv":[0,0,0,0]}},
			{"size": [8, 8, 0.1], "pos": [-5.65, 24, 31.2], "origin": [0, 0, 0], "north":{"uv":[0,0,0,0]},"east":{"uv":[0,0,0,0]},"south":{"uv":[0,0,0,0]},"west":{"uv":[0,0,16,16]},"up":{"uv":[0,0,0,0]},"down":{"uv":[0,0,0,0]}}
		]
	},
	block: {
		texture: 'assets/missing.png',
		elements: [
			{"size": [16,16,16], "pos": [8, -7.98, 8], "origin": [0, 0, 0], "north":{"uv":[0,0,16,16]},"east":{"uv":[0,0,16,16]},"south":{"uv":[0,0,16,16]},"west":{"uv":[0,0,16,16]},"up":{"uv":[0,0,16,16]},"down":{"uv":[0,0,16,16]}}
		]
	},
	frame_block: {
		texture: 'assets/missing.png',
		elements: [
			{"size": [16,16,16], "pos": [8, 8, 8], "origin": [0, 0, 0], "north":{"uv":[0,0,16,16]},"east":{"uv":[0,0,16,16]},"south":{"uv":[0,0,16,16]},"west":{"uv":[0,0,16,16]},"up":{"uv":[0,0,16,16]},"down":{"uv":[0,0,16,16]}}
		]
	},
	flower_pot: {
		texture: 'assets/flower_pot.png',
		elements: [
			{
				"size": [6, 6, 6],
				"pos": [0, 3, 0],
				"origin": [0, 0, 0],
				"north": {"uv":[0, 10, 6, 16]},
				"east": {"uv":[0, 10, 6, 16]},
				"south": {"uv":[0, 10, 6, 16]},
				"west": {"uv":[0, 10, 6, 16]},
				"up": {"uv":[0, 5, 6, 11]},
				"down": {"uv":[0, 10, 6, 16]}
			},
			{
				"size": [6, 0, 6],
				"pos": [0, 4, 0],
				"origin": [0, 0, 0],
				"up": {"uv":[10, 0, 16, 6]},
				"down": {"uv":[0, 0, 1, 1]},
			}
		]
	},
	frame: {
		texture: 'assets/item_frame.png',
		elements: [
			{"size": [10,10,0.5], "pos": [8, 8, -0.25], "origin": [0, 0, 0], "north":{"uv":[3,3,13,13]},"east":{"uv":[0,0,0,0]},"south":{"uv":[0,0,0,0]},"west":{"uv":[0,0,0,0]},"up":{"uv":[0,0,0,0]},"down":{"uv":[0,0,0,0]}},

			{"size": [1,12,1], "pos": [13.5, 8, -0.5], "origin": [0, 0, 0], "north":{"uv":[2,2,3,14]},"east":{"uv":[2,2,3,14]},"south":{"uv":[2,2,3,14]},"west":{"uv":[2,2,3,14]},"up":{"uv":[2,2,3,3]},"down":{"uv":[2,2,3,3]}},
			{"size": [1,12,1], "pos": [2.5,  8, -0.5], "origin": [0, 0, 0], "north":{"uv":[2,2,3,14]},"east":{"uv":[2,2,3,14]},"south":{"uv":[2,2,3,14]},"west":{"uv":[2,2,3,14]},"up":{"uv":[2,2,3,3]},"down":{"uv":[2,2,3,3]}},

			{"size": [10,1,1], "pos": [8, 13.5, -0.5], "origin": [0, 0, 0], "north":{"uv":[3,2,13,3]},"east":{"uv":[3,2,13,3]},"south":{"uv":[3,2,13,3]},"west":{"uv":[3,2,13,3]},"up":{"uv":[3,2,13,3]},"down":{"uv":[3,2,13,3]}},
			{"size": [10,1,1], "pos": [8, 2.5, -0.5], "origin": [0, 0, 0], "north":{"uv":[3,13,13,14]},"east":{"uv":[3,13,13,14]},"south":{"uv":[3,13,13,14]},"west":{"uv":[3,13,13,14]},"up":{"uv":[3,13,13,14]},"down":{"uv":[3,13,13,14]}}
		],
	},
	frame_top_block: {
		texture: 'assets/missing.png',
		elements: [
			{"size": [16,16,16], "pos": [8, -8.01, 8], "origin": [0, 0, 0], "north":{"uv":[0,0,16,16]},"east":{"uv":[0,0,16,16]},"south":{"uv":[0,0,16,16]},"west":{"uv":[0,0,16,16]},"up":{"uv":[0,0,16,16]},"down":{"uv":[0,0,16,16]}}
		]
	},
	frame_top: {
		texture: 'assets/item_frame.png',
		elements: [
			{"rotation": [90, 0, 0], "size": [10,10,0.5], "pos": [8, -8, -0.25], "origin": [8, -8, 8], "north":{"uv":[3,3,13,13]},"east":{"uv":[0,0,0,0]},"south":{"uv":[0,0,0,0]},"west":{"uv":[0,0,0,0]},"up":{"uv":[0,0,0,0]},"down":{"uv":[0,0,0,0]}},

			{"rotation": [90, 0, 0], "size": [1,12,1], "pos": [13.5, -8, -0.5], "origin": [8, -8, 8], "north":{"uv":[2,2,3,14]},"east":{"uv":[2,2,3,14]},"south":{"uv":[2,2,3,14]},"west":{"uv":[2,2,3,14]},"up":{"uv":[2,2,3,3]},"down":{"uv":[2,2,3,3]}},
			{"rotation": [90, 0, 0], "size": [1,12,1], "pos": [2.5,  -8, -0.5], "origin": [8, -8, 8], "north":{"uv":[2,2,3,14]},"east":{"uv":[2,2,3,14]},"south":{"uv":[2,2,3,14]},"west":{"uv":[2,2,3,14]},"up":{"uv":[2,2,3,3]},"down":{"uv":[2,2,3,3]}},

			{"rotation": [90, 0, 0], "size": [10,1,1], "pos": [8, -2.5, -0.5], "origin": [8, -8, 8], "north":{"uv":[3,2,13,3]},"east":{"uv":[3,2,13,3]},"south":{"uv":[3,2,13,3]},"west":{"uv":[3,2,13,3]},"up":{"uv":[3,2,13,3]},"down":{"uv":[3,2,13,3]}},
			{"rotation": [90, 0, 0], "size": [10,1,1], "pos": [8, -13.5, -0.5], "origin": [8, -8, 8], "north":{"uv":[3,13,13,14]},"east":{"uv":[3,13,13,14]},"south":{"uv":[3,13,13,14]},"west":{"uv":[3,13,13,14]},"up":{"uv":[3,13,13,14]},"down":{"uv":[3,13,13,14]}}
		]
	},
	shelf: {
		texture: 'assets/oak_shelf.png',
		elements: [
			{"size": [16,16,3], "pos": [8, 8, 14.5], "origin": [0, 0, 0], "north":{"uv":[0,0,8,8]},"east":{"uv":[8,0,9.5,8]},"south":{"uv":[8,0,16,8]},"west":{"uv":[14.5,0,16,8]},"up":{"uv":[16,5,8,3.5]},"down":{"uv":[16,6,8,4.5]}},
			{"size": [16,4,2], "pos": [8, 2, 12], "origin": [0, 0, 0], "north":{"uv":[0,6,8,8]},"east":{"uv":[1.5,6,2.5,8]},"south":{"uv":[0,0,0,0]},"west":{"uv":[5.5,6,6.5,8]},"up":{"uv":[8,3.5,16,4.5]},"down":{"uv":[16,4.5,8,3.5]}},
			{"size": [16,4,2], "pos": [8, 14, 12], "origin": [0, 0, 0], "north":{"uv":[0,0,8,2]},"east":{"uv":[1.5,0,2.5,2]},"south":{"uv":[0,0,0,0]},"west":{"uv":[5.5,0,6.5,2]},"up":{"uv":[16,6,8,5]},"down":{"uv":[8,5,16,6]}}
		]
	}
};
export default DisplayReferences;

